import { getRoot } from 'mobx-state-tree';
import { EnrollmentRootStore } from './EnrollmentRootStore';

export function getRootStore(self: any): EnrollmentRootStore {
  return getRoot(self) as EnrollmentRootStore;
}
